import React, { useState, useRef } from 'react';
import c from 'classnames';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import ListCard from '@wix/da-ds/pkg/List/ListCard';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../types/deviation';
import TierCreatorReduxModule from '../redux/creator/ModuleLoadable';
import TierConsumerReduxModule from '../redux/consumer/ModuleLoadable';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import DeleteTier from '../ActionItems/DeleteTier';
import EditTier from '../ActionItems/EditTier';
import GoToTier from '../ActionItems/GoToTier';
import ManageTier from '../ActionItems/ManageTier';
import ShareInPost from '../ActionItems/ShareInPost';
import ShareOnSocial from '../ActionItems/ShareOnSocial';
import ConnectDiscord from '../ActionItems/ConnectDiscord';
import s from './MoreActionsButton.scss';
const MoreActionsButton = ({ isOwner , deviation , className  })=>{
    var _deviation_tier;
    const [isMenuShown, setIsMenuShown] = useState(false);
    const { isUserSubscribed  } = useSubscriptionTier(deviation);
    const isDraft = ((_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.state) === 'draft';
    const rootRef = useRef(null);
    useOnOutsideClick([
        rootRef
    ], ()=>setIsMenuShown(false));
    const toggleMenuVisibility = ()=>setIsMenuShown(!isMenuShown);
    const renderOwnerMenuItems = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, !isDraft && /*#__PURE__*/ React.createElement(GoToTier, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(EditTier, {
            deviation: deviation
        }), !isDraft && /*#__PURE__*/ React.createElement(ShareOnSocial, {
            deviation: deviation
        }), !isDraft && /*#__PURE__*/ React.createElement(ShareInPost, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(DeleteTier, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null));
    const renderVisitorMenuItems = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(GoToTier, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(ShareOnSocial, {
            deviation: deviation
        }), isUserSubscribed && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConnectDiscord, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(ManageTier, {
            deviation: deviation
        })), /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null));
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement(IconButtonWithBackground, {
        icon: EllipsisIcon,
        size: IconSize.MEDIUM,
        onClick: toggleMenuVisibility,
        biData: isMenuShown ? undefined : {
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            sectionname: 'tiers'
        }
    }), isMenuShown && /*#__PURE__*/ React.createElement(ListCard, {
        className: s['menu']
    }, isOwner ? renderOwnerMenuItems() : renderVisitorMenuItems()));
};
MoreActionsButton.displayName = 'MoreActionsButton';
export default MoreActionsButton;
